import React from 'react';
import { DiscoverListElement } from '../Discover/DiscoverListElement';


export class DiscoverList extends React.Component {
	constructor(props) {
		super(props);
	}

	renderDiscoverItems() {
		let elementsToBeRendered = [];

		this.props.discoverData.map(element => {
			if (element.visibleByFilter) {
				elementsToBeRendered.push(
					<DiscoverListElement key={element.id} discoverElement={element} selectArticleAction={this.props.selectArticleAction}/>
				);
			}	
		});
	
		return elementsToBeRendered;
	}

	render() {
		let renderedItems = this.renderDiscoverItems();
		
		return (
			<ul className="row clearfix discover__item-list">
				{renderedItems}
			</ul>
		);
	}
};


// WEBPACK FOOTER //
// ./src/components/Discover/DiscoverList.js